import { type LineChartFactory, LineChart as MantineLineChart } from "@mantine/charts";
import { componentWrapper } from "../../utilities";
import styles from "./line-chart.module.scss";
import { LINE_CHART_DOT_RADIUS } from "./line-chart.constants";
import type { IProps } from "./line-chart.types";
import { useMemo } from "react";

const LineChart = componentWrapper<LineChartFactory, IProps>("LineChart", (props, ref) => {
    const { type, lineChartProps, mouseEvents, ...otherProps } = props;

    const combinedLineChartProps = useMemo(
        () => ({
            ...lineChartProps,
            ...mouseEvents,
        }),
        [lineChartProps, mouseEvents]
    );
    return (
        <MantineLineChart
            ref={ref}
            classNames={{ root: styles["container"] }}
            data-type={type || "default"}
            curveType="natural"
            {...otherProps}
            lineChartProps={combinedLineChartProps}
            dotProps={{ r: 0, ...props.dotProps }}
            activeDotProps={{ r: LINE_CHART_DOT_RADIUS, ...props.activeDotProps }}
        />
    );
});

export { LineChart };

// TODO: Watchtower 2.0
// - Revisit this later: Colours for series to always appear in the specific order
